<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <h2>
      Dodajte novo opombo:
    </h2>
    <!-- uporabim kar LocationForm namesto, da delam novo! -->
    <LocationForm
      :barve="false"
      :opomba="true"
      @save="save"
      @cancel="cancel"
      ref="form"
    />

    <div class="row mt-10">
      <div class="col">
        <h2>
          Skupine:
        </h2>
      </div>
      <div class="col">
        <PopupPickerSkupineOpomba
          :categoryId="id"
          :levelCategories="localCategories"
          :allCategories="categories"
          @izbraneKategorije="temp"
        />
      </div>
    </div>
    <v-row>
      <v-col>
        <v-simple-table fixed-header>
          <template v-slot:default>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row v-dragula="localPrinters" drake="articles">
      <v-col cols="12" v-for="item of localCategories" :key="item.id" class="pt-0 pb-0">
        <TitleOnlyCard
          :title="item.name"
          :editable="false"
          :deleteable="false"
          :draggable="false"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import LocationForm from '@/components/LocationForm'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import { objectToArray } from '@/utils/object'
import PopupPickerSkupineOpomba from '@/components/PopupPickerSkupineOpomba'
import TitleOnlyCard from '@/components/TitleOnlyCard'

export default {
  components: {
    LocationForm,
    PopupPickerSkupineOpomba,
    TitleOnlyCard
  },
  mixins: [
    asyncDataStatus
  ],
  data () {
    return {
      koncano: false,
      localCategories: []
    }
  },
  computed: {
    categories () {
      return objectToArray(this.$store.state.categories.items)
    },
    selectedCategories () {
      return objectToArray(this.$store.state.businessUnits.komentarjiSkupine[this.id])
    }
  },
  methods: {
    ...mapActions('businessUnits', ['setComments', 'setCommentCategory', 'getCommentCategories', 'deleteCommentCategory']),
    ...mapActions('categories', { loadCategories: 'loadItems' }),
    temp (data) {
      this.localCategories = [ ...this.localCategories, ...data.listaKategorij ]
    },
    save ({ data, repeat = false }) {
      const redirect = repeat ? null : 'MyCompanyComments'
      data = { ...data, name: data.comment }
      this.setComments({ ...data })
        .then(item => {
          /* this.$notify({
            type: 'success',
            text: 'Podatki so bili uspešno shranjeni.'
          }) */
          // tle se posamezni kategoriji dolocimo komentar!
          this.setCommentCategory({ listaKategorij: this.localCategories, commentId: item.data.items[0].id })
            .then(() => {
              if (redirect) {
                this.$router.push({ name: redirect })
              } else {
                this.$refs.form.clearForm()
              }
            })
        })
        .catch((err) => {
          if (err.response.status === 400) {
            this.$notify({
              type: 'error',
              text: 'Opomba že obstaja!'
            })
          }
        })
    },
    cancel () {
      this.$router.push({ name: 'MyCompanyComments' })
    }
  },
  created () {
    this.loadCategories()
      .then(response => {
        this.localCategories = []
        this.asyncDataStatus_fetched()
        this.koncano = true
      })
  }
}
</script>
